import { createTheme } from '@material-ui/core/styles'
import NotoSansTC from './fonts/NotoSansTC-Regular.otf';

const notoFont = {
    fontFamily: 'Noto Sans TC',
    src: `local('Noto Sans TC'), url(${NotoSansTC}) format('opentype')`,
};

const Theme = createTheme(
    {

        "overrides": {
            "MuiCssBaseline": {
                '@global': {
                    '@font-face': [notoFont],
                },
            },
        },
        "typography": {
            "fontFamily": 'Noto Sans TC',
        },
    }
);

export default Theme;